import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { authenticaitonModel } from '../authentication/model/authenticaiton.model';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = false;
  currentUserLogged: authenticaitonModel = null;

  constructor(private _router: Router) {
    this._router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.ngOnInit();
      }
    })
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      //window.location.href = "/authentication";
    }
  }

  loggedUser() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      this.currentUserLogged = currentUser;
      return true;
    }
  }

  logout() {
    localStorage.clear();
    this.currentUserLogged = null;
    this._router.navigate(['/authentication']);
  }
}
